<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from 'vue-i18n'

import BlockOnlineGamesIcon from '@kidzonet/dashboard-policy-icons/src/BlockOnlineGames.vue'
import BlockOnlineMusicAndVideoIcon from '@kidzonet/dashboard-policy-icons/src/BlockOnlineMusicAndVideo.vue'
import BlockSocialMediaIcon from '@kidzonet/dashboard-policy-icons/src/BlockSocialMedia.vue'
import BlockYoutubeIcon from '@kidzonet/dashboard-policy-icons/src/BlockYoutube.vue'
import ProtectionOnIcon from '@kidzonet/dashboard-policy-icons/src/ProtectionOn.vue'
import SafeSearchIcon from '@kidzonet/dashboard-policy-icons/src/SafeSearch.vue'
import SafeYouTubeIcon from '@kidzonet/dashboard-policy-icons/src/SafeYouTube.vue'
import { useDasboardPolicyStore } from '@kidzonet/dashboard-policy-store'
import PolicyItem from '@kidzonet/dashboard-policy-widget'
import { getPolicyName } from '@kidzonet/use-policy'

defineEmits(['close'])

const store = useDasboardPolicyStore()

const { t } = useI18n()

const policyList = computed(() => store.policyList.filter(({ name }) => name !== 'allow_all'))
</script>

<template>
    <div class="policy-description kidzonet-dashboard-widget">
        <div class="policy-description__header">
            <h3>{{ t('dashboard_v2.policy_page.policy_description.header') }}</h3>
            <v-btn
                variant="tonal"
                density="compact"
                icon="$close"
                @click="$emit('close')"
                aria-label="Close dialog button"
            />
        </div>
        <div
            v-if="policyList && policyList.length > 0"
        >
            <PolicyItem
                v-for="{ name, id } in policyList"
                :key="name"
                :name="name"
                :header="getPolicyName(name)"
                :subheader="t(`policy.${name}.long_description`)"
                :id="id"
                class="policy-description__item"
                v-ripple="false"
                hide-tooltip
            >
                <template #icon>
                    <ProtectionOnIcon v-if="name === 'holiday_time'" />
                    <BlockYoutubeIcon v-if="name === 'youtube'" />
                    <BlockSocialMediaIcon v-else-if="name === 'social_media'" />
                    <BlockOnlineGamesIcon v-else-if="name === 'online_games'" />
                    <BlockOnlineMusicAndVideoIcon v-else-if="name === 'online_music_and_video'" />
                </template>
                <div>&nbsp;</div>
            </PolicyItem>
            <PolicyItem
                v-ripple="false"
                :header="t(`common.manual_policy.safe_search`)"
                :subheader="t(`common.manual_policy.safe_search_description`)"
                class="policy-description__item"
                hide-tooltip
            >
                <template #icon>
                    <SafeSearchIcon />
                </template>
                <div>&nbsp;</div>
            </PolicyItem>
            <PolicyItem
                v-ripple="false"
                :header="t(`common.manual_policy.safe_youtube`)"
                :subheader="t(`common.manual_policy.safe_youtube_description`)"
                class="policy-description__item"
                hide-tooltip
            >
                <template #icon>
                    <SafeYouTubeIcon />
                </template>
                <div>&nbsp;</div>
            </PolicyItem>
        </div>
    </div>
</template>

<style>
    .policy-description {
        overflow-y: scroll;
        inline-size: 700px;
        block-size: 600px;

        &__header {
            display: flex;
            justify-content: space-between;
        }

        &__item {
            margin: 1em 0;
            &:hover {
                cursor: auto;
                background-color: inherit !important;
            }
        }

        @media(max-width: 800px) {
            inline-size: auto
        }
    }
</style>
